import { Pipe, PipeTransform } from '@angular/core';
import { PhxDateFnsFormatter } from '../../services/phx-date-fns-formatter-service';

export type PhxFormatTypes = 'long' | 'compact' | 'tiny' | 'table';
export type PhxVariationTypes = 'date-only' | 'day-date' | 'date-time' | 'day-date-time' | 'time-only' | 'round-hours' | 'month-year' | 'complete-time';

const DATE_FORMATS = {
  'long-date-only': 'LLLL dd, yyyy',
  'long-day-date': 'EEEE, LLLL dd, yyyy',
  'long-date-time': 'LLLL dd, yyyy h:mm a',
  'long-day-date-time': 'EEEE, LLLL dd, yyyy h:mm a',
  'long-time-only': 'h:mm a',
  'long-round-hours': 'h a',
  'long-month-year': 'LLLL yyyy',
  'long-complete-time': 'h:mm:ss a',
  'compact-date-only': 'LLL dd, yyyy',
  'compact-day-date': 'EEE, LLLL dd, yyyy',
  'compact-date-time': 'LLL dd, yyyy h:mm a',
  'compact-day-date-time': 'EEE, LLL dd, yyyy h:mm a',
  'compact-time-only': 'h:mm a',
  'compact-round-hours': 'h a',
  'compact-month-year': 'LLL yyyy',
  'compact-complete-time': 'h:mm:ss a',
  'tiny-date-only': 'M/d/yyyy',
  'tiny-day-date': 'EEEEEE M/d/yyyy',
  'tiny-date-time': 'M/d/yyyy h:mm a',
  'tiny-day-date-time': 'EEEEEE M/d/yyyy h:mm a',
  'tiny-time-only': 'h:mm a',
  'tiny-round-hours': 'h a',
  'tiny-month-year': 'MM/yyyy',
  'tiny-complete-time': 'h:mm:ss a',
  'table-date-only': 'MM/dd/yyyy',
  'table-day-date': null,
  'table-date-time': 'MM/dd/yyyy hh:mm a',
  'table-day-date-time': null,
  'table-time-only': 'hh:mm a',
  'table-round-hours': 'hh:00 a',
  'table-month-year': null,
  'table-complete-time': 'hh:mm:ss a',
};

@Pipe({ name: 'phxDateTimeFormat' })
export class PhxDateTimeFormatPipe implements PipeTransform {
  constructor(private _dateFnsFormatter: PhxDateFnsFormatter) {}

  public transform(date: Date | string | number, formatType: PhxFormatTypes, variation: PhxVariationTypes, timezone?: string): string {
    const dateFormat: string = DATE_FORMATS[`${formatType}-${variation}`];
    if (!dateFormat) return 'Not Supported';
    return this._dateFnsFormatter.format(date, dateFormat, timezone);
  }
}